var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collapsee-body ml-md-5 mr-4 ml-2 mr-2" },
    [
      _c(
        "b-row",
        [
          _vm.isSample
            ? _c(
                "b-col",
                { staticClass: "pt-1 pr-0", attrs: { cols: "auto" } },
                [
                  _c(
                    "div",
                    { staticClass: "state p-primary p-on" },
                    [
                      _c("icon", {
                        staticClass: "sample-document-icon",
                        attrs: { name: "file-text-o" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-col", [
            _vm.isSample
              ? _c("strong", [
                  _vm._v(_vm._s(_vm.$t("documents.sampleDocument")) + " "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-row align-items-center" },
              [
                _vm.loadingPreview
                  ? _c("inline-loader", { staticClass: "mr-1" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "text-left text-primary mb-0 preview-document text-truncate",
                    class: {
                      disabled: _vm.loadingPreview,
                      clickable: !_vm.isUploadedByCoApplicant,
                    },
                    on: { click: _vm.handlePreviewClick },
                  },
                  [_vm._v("\n          " + _vm._s(_vm.fileName) + "\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("p", { staticClass: "text-left date text-gray mb-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("formatDateHour")(_vm.createdAt)) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("document-row-toolbar", {
                  attrs: {
                    "uploaded-by-co-applicant": _vm.isUploadedByCoApplicant,
                    downloading: _vm.downloadingDocument,
                  },
                  on: { download: _vm.handleDownloadDocument },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right px-0", attrs: { cols: "4", md: "2" } },
            [
              !_vm.isSample
                ? _c(
                    "a",
                    {
                      staticClass:
                        "hidden add-comment-text text-primary clickable bold small",
                      on: {
                        click: function ($event) {
                          return _vm.toggleComments()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("countComments")(
                              _vm.document,
                              !_vm.showComments
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut faster",
          },
        },
        [
          _vm.showComments
            ? _c("document-comments", {
                attrs: { comments: _vm.comments },
                on: { submit: _vm.handleCommentSubmit },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("document-preview-modal", {
        ref: "previewDocumentModal",
        attrs: {
          "file-name": _vm.fileName,
          "document-id": _vm.documentId,
          url: _vm.previewDocumentUrl,
          "document-is-downloading": _vm.downloadingDocument,
        },
        on: {
          "download-document": _vm.handleDownloadDocument,
          hide: _vm.handlePreviewDocumentModalHide,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }